import { render, staticRenderFns } from "./CustomerBrowse.vue?vue&type=template&id=17c3323a"
import script from "./CustomerBrowse.vue?vue&type=script&lang=ts"
export * from "./CustomerBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17c3323a')) {
      api.createRecord('17c3323a', component.options)
    } else {
      api.reload('17c3323a', component.options)
    }
    module.hot.accept("./CustomerBrowse.vue?vue&type=template&id=17c3323a", function () {
      api.rerender('17c3323a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contacts/CustomerBrowse.vue"
export default component.exports